/**
 * 分隔符组件
 *
 * 这是聊天系统中用于显示分隔符的简单组件，用于在聊天记录中插入视觉分隔线。
 * 通常用于区分不同的会话、时间段或消息组。
 * @param className - 可选的CSS类名，用于自定义样式
 * @param text - 分隔符显示的文本内容
 */
export default function Separator({ className = '', text }) {
  return (
    <div className={'flex items-center justify-center py-4 text-sm text-gray-400 ' + className}>
      ----------- {text} -----------
    </div>
  )
}
